import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

import { ReportPropertyDetailService } from '../../residential-property/residential-property-detail.service';
import { GlobalContants } from 'src/app/common/constants/global.contants';
import { ReportService } from 'src/app/reports/services/report.service';
import { DecimalPipe } from '@angular/common';
import { SharedService } from 'src/app/common/services/shared.service';

@Component({
  selector: 'app-report-property-info',
  templateUrl: './report-property-info.component.html',
  styleUrls: ['./report-property-info.component.scss']
})
export class ReportPropertyInfoComponent implements OnChanges {

  @Input() propertyInfo: any;
  unitType = GlobalContants.keySymbolContants.squareMeterUnit;
  propertyInfomation: any = [];
  overViewPropertySummary: any = null;
  CurrencyCode: any;
  @Output() isEmpatyCheck = new EventEmitter();

  constructor(private reportPropertyDetailService: ReportPropertyDetailService,
    private reportService: ReportService, private decimalPipe: DecimalPipe,
    private sharedService : SharedService
  ){}

  ngOnChanges(): void {
    this.CurrencyCode = this.reportPropertyDetailService.CurrencyCode;
    this.sharedService.language$.subscribe({
      next : (res: any) => {
        this.getPropertyInfo();
      },
      error : (err:any) => { }
    })
  }

  // getPropertyOverviewSummary() {
  //   this.reportPropertyDetailService.getOverviewPropertySummary().subscribe(
  //     {
  //       next: (res: any) => {
  //         if (res.status === 200) {
  //          this.overViewPropertySummary = res.data;
  //          if(this.overViewPropertySummary?.land_area) this.overViewPropertySummary['land_area']=this.reportService.formatInternationNum(this.overViewPropertySummary?.land_area)
  //           if(this.overViewPropertySummary?.setback) this.overViewPropertySummary['setback']=this.reportService.formatInternationNum(this.overViewPropertySummary?.setback)
  //         } else {
  //           this.overViewPropertySummary = null;
  //         }
  //       }
  //     }
  //   )
  // }

  getPropertyInfo(){
    this.reportPropertyDetailService.getPropertyInfo().subscribe(
      {
        next: (res: any) => {
          if (res.status === 200 && res.data) {
            let obj:any[] = res.data;
            obj.sort((a: any, b: any) => (Number(a.sort_order) - Number(b.sort_order)))
            this.propertyInfomation = obj;
            let isPropertyInfomation = this.propertyInfomation.find((x: any) => x.value > 0);

            isPropertyInfomation ? this.isEmpatyCheck.emit(true) : this.isEmpatyCheck.emit(false);
          } else {
            this.propertyInfomation = [];
            this.isEmpatyCheck.emit(false);
          }
        },
        error:(err)=> {
          this.propertyInfomation = [];
          this.isEmpatyCheck.emit(false);
        },
      }
    )
  }


}
